import Consent from '../../components/survey/types/Consent';
import Finished from '../../components/survey/types/Finished';
import YesNo from '../../components/survey/types/YesNo';
import YesNoAlt from '../../components/survey/types/YesNoAlt';
import RatingScale from '../../components/survey/types/RatingScale';
import Comment from '../../components/survey/types/Comment';
import ClientDetails from '../../components/survey/types/ClientDetails';
import RatingTable from '../../components/survey/types/RatingTable';
import Asq3FollowUp from '../../components/survey/types/Asq3FollowUp';
import AsqSeTable from '../../components/survey/types/AsqSeTable';

export class SurveyQuestionFactory {
  static make(type) {
    switch (type) {
      case 'Consent':
        return Consent;

      case 'Finished':
        return Finished;

      case 'Yes/No':
        return YesNo;

      case 'Yes/No/Alt':
        return YesNoAlt;

      case 'Rating Scale':
        return RatingScale;

      case 'Comment':
        return Comment;

      case 'Client Details':
        return ClientDetails;

      case 'Rating Table':
        return RatingTable;

      case 'ASQ3 Follow Up':
        return Asq3FollowUp;
      case 'ASQ SE Table':
        return AsqSeTable;

      default:
        return () => {};
    }
  }
}
